var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l(([...Array(4)]),function(chart,i){return _c('v-col',{key:i,style:('height: ' + (_vm.blockHeight * 1.5) + 'px;'),attrs:{"cols":"12","lg":"6"}},[_c('KPI_ModalChart',{attrs:{"layout":_vm.layout,"title":_vm.layout.chartNames[i],"chart":_vm.charts[i]}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }